import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PropTypes from 'prop-types';
import { ReportCardHeaderTitle } from '../ReportCard/ReportCardHeaderTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ReportCardGutter({
  children
}) {
  return /*#__PURE__*/_jsx(View, {
    paddingInlineEnd: "500",
    paddingInlineStart: "0",
    paddingBlockStart: "0",
    paddingBlockEnd: "0",
    children: children
  });
}
function convertToPixelString(value) {
  if (typeof value === 'number') {
    return `${value}px`;
  }
  return value;
}

/**
 *
 * @deprecated ReportCard is deprecated in favor of ReportCardV2. See https://private.hubteamqa.com/trellis-reporting-storybook/?path=/story/components-reportcardv2--page or reach out to us at #reporting-enablement for more information.
 */
export function ReportCard({
  children,
  header,
  width,
  height,
  description,
  menuActions,
  convertToTableToggle,
  trendLineToggle,
  anomalyDetectionToggle,
  reportDeprecationAlert,
  alert,
  isMobile,
  flush,
  reportEditors,
  borderStyle = 'solid'
}) {
  const hasToggle = convertToTableToggle || trendLineToggle || anomalyDetectionToggle;
  const inlineSize = convertToPixelString(width);
  const blockSize = convertToPixelString(height);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    blockSize: blockSize,
    inlineSize: inlineSize,
    compact: true,
    flush: flush,
    marginBlockEnd: flush ? '0' : undefined,
    borderStyle: borderStyle,
    children: [header && /*#__PURE__*/_jsx(CardHeader, {
      title: /*#__PURE__*/_jsx(ReportCardHeaderTitle, {
        header: header,
        description: description
      }),
      toolbar: menuActions && /*#__PURE__*/_jsx(Dropdown, {
        id: "widget-settings",
        "data-test-id": "widget-actions-menu",
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "widget.actionsLabel"
        }),
        buttonUse: "link",
        children: /*#__PURE__*/_jsx(List, {
          wrapChildren: true,
          children: menuActions.map(Action => /*#__PURE__*/_jsx(Action, {}, Action.name))
        })
      })
    }), reportDeprecationAlert && /*#__PURE__*/_jsx(ReportCardGutter, {
      children: reportDeprecationAlert
    }), (reportEditors || hasToggle) && !header && /*#__PURE__*/_jsx(ReportCardGutter, {
      children: reportEditors || /*#__PURE__*/_jsxs(TFlex, {
        justify: "end",
        direction: "row",
        gap: 10,
        children: [trendLineToggle, anomalyDetectionToggle, convertToTableToggle]
      })
    }), /*#__PURE__*/_jsxs(CardSection, {
      scrollable: true,
      paddingInlineStart: isMobile || flush ? '0' : undefined,
      paddingInlineEnd: isMobile || flush ? '0' : undefined,
      paddingBlockStart: isMobile || flush ? '0' : undefined,
      flush: flush,
      display: "flex",
      flexDirection: "column"
      // Can't use margin for this because the CardSection aggressively sets marginBlockEnd to 0 for the last child
      ,
      paddingBlockEnd: "600",
      children: [alert, children]
    })]
  });
}
ReportCard.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  description: PropTypes.node,
  menuActions: PropTypes.array,
  alert: PropTypes.object,
  style: PropTypes.object,
  convertToTableToggle: PropTypes.object,
  trendLineToggle: PropTypes.object
};
export default ReportCard;